import { Text } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { CanalDeContacto, CarlineSelect, CodigoPostal, ConsentQuestion, Loading, NombreApellidos, TelefonoEmail } from 'src/components';
import { useIsComerciales } from 'src/feature-app/hooks';
import { LayoutWrapper } from 'src/feature-app/Screen';
import { ConfirmacionLeadsNoQuestions, LegalDatosPersonalesLeads } from 'src/forms';
import { MapaLeadsInPage } from 'src/forms/Leads/InPage';
import { FormInfo, Steps } from 'src/types';
import { leadsTestDrivePartialData } from '.';
import { LeadGenericoController } from '../LeadGenericoController';
import { LeadsFormsProps } from '../LeadGenericoForm';
import { MapaLeads } from '../MapaLeads';
import { useInitializeLeadForm } from '../use-initialize-lead-form';

const getMapaFields = (inPage: boolean) => {
	if (inPage === true) {
		return <MapaLeadsInPage formName="testDrive" />;
	} else {
		return <MapaLeads formName="testDrive" />;
	}
};

export enum TestDriveSteps {
	Modelo,
	Mapa,
	NombreApellido,
	CodigoPostal,
	Contacto,
	EmailTelefono,
	Lssi,
	Tmk,
	Confirmacion,
}

export function TestDriveForm({ updatedFormData, inPage, isConfigurador, isLeadDealer }: LeadsFormsProps) {
	const isComerciales = useIsComerciales();
	const [partialData, setPartialData] = useState(null);

	useEffect(() => {
		if (updatedFormData) {
			setPartialData(updatedFormData);
		} else {
			setPartialData(leadsTestDrivePartialData(isConfigurador, isLeadDealer));
		}
	}, []);

	const defaultSteps: Steps[] = [
		{
			title: (
				<>
					<Text bold>¿Qué modelo </Text> te apetece conducir?
				</>
			),
			fields: (
				<LayoutWrapper>
					<CarlineSelect useCarline={true} />
				</LayoutWrapper>
			),
			screenIndex: TestDriveSteps.Modelo,
			name: 'Modelo',
			outputs: ['modelo'],
			outputsText: ['modelo'],
		},
		isLeadDealer
			? null
			: {
					screenIndex: TestDriveSteps.Mapa,
					name: 'Mapa',
					multiStep: true,
					component: getMapaFields(inPage),
			  },
		{
			title: (
				<>
					Para poder contactar contigo, necesitamos saber <Text bold>quién eres</Text>
					<LegalDatosPersonalesLeads />
				</>
			),
			alternateTitle: (
				<>
					Para poder contactar contigo, necesitamos saber <Text bold>quién eres</Text>
				</>
			),
			fields: (
				<LayoutWrapper>
					<NombreApellidos />
				</LayoutWrapper>
			),
			screenIndex: TestDriveSteps.NombreApellido,
			name: 'NombreApellido',
			outputs: ['name', 'surname', 'secondSurname'],
			outputsText: ['name', 'surname', 'secondSurname'],
		},
		{
			title: (
				<>
					También nos gustaría conocer <Text bold>tu código postal</Text>
				</>
			),
			fields: (
				<LayoutWrapper>
					<CodigoPostal />
				</LayoutWrapper>
			),
			screenIndex: TestDriveSteps.CodigoPostal,
			name: 'CodigoPostal',
			outputs: ['codigoPostal'],
			outputsText: ['codigoPostal'],
		},
		{
			title: (
				<>
					<Text bold>¿Cómo prefieres </Text>que contactemos contigo?
					<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
				</>
			),
			fields: (
				<LayoutWrapper>
					<CanalDeContacto />
				</LayoutWrapper>
			),
			screenIndex: TestDriveSteps.Contacto,
			name: 'Contacto',
			outputs: ['contacto'],
			outputsText: ['contacto'],
		},
		{
			title: (
				<>
					Para ello necesitaremos <Text bold>tus datos de contacto</Text>
				</>
			),
			fields: (
				<LayoutWrapper>
					<TelefonoEmail hidePrefijo={isComerciales} requiredTelefono requiredEmail />
				</LayoutWrapper>
			),
			screenIndex: TestDriveSteps.EmailTelefono,
			name: 'EmailTelefono',
			outputs: ['cellphone', 'email'],
			outputsText: ['cellphone', '/', 'email'],
		},
		{
			fields: <ConsentQuestion questionType="lssi" />,
			screenIndex: TestDriveSteps.Lssi,
			name: 'lssi',
			outputs: ['lssi'],
		},
		{
			fields: <ConsentQuestion questionType="tmk" />,
			screenIndex: TestDriveSteps.Tmk,
			name: 'tmk',
			outputs: ['tmk'],
		},
		{
			fields: <ConfirmacionLeadsNoQuestions />,
			screenIndex: TestDriveSteps.Confirmacion,
			isLastStep: true,
			hidePreviousStep: true,
			name: 'Confirmacion',
		},
	];

	const filteredSteps = defaultSteps.filter((step) => step !== null);

	const { loading, steps, firstStep, lastStep } = useInitializeLeadForm(filteredSteps, false, inPage);

	const citaVentaInfo: Partial<FormInfo> = {
		numberOfScreens: steps.length,
	};

	return loading ? <Loading /> : <LeadGenericoController steps={steps} leadData={partialData} leadInfo={citaVentaInfo} firstStep={firstStep} lastStep={lastStep} inPage={inPage} isConfigurador={isConfigurador} />;
}
